import React, { Fragment } from 'react';

import * as Styled from './FlipText.styles';

const FlipText = ({ text, children, ...props }) => {
  const firstLetterAnimation = (index) => ({
    variants: {
      initial: { y: 0 },
      hovered: {
        y: '-100%',
        transition: {
          duration: 0.25,
          delay: 0.025 * index,
          ease: [0.215, 0.61, 0.355, 1],
        },
      },
    },
  });

  const secondLetterAnimation = (index) => ({
    variants: {
      initial: { y: '100%' },
      hovered: {
        y: 0,
        transition: {
          duration: 0.25,
          delay: 0.025 * index,
          ease: [0.215, 0.61, 0.355, 1],
        },
      },
    },
  });

  const hasText = typeof text === 'string' && text.length > 0;

  return (
    <Styled.FlipText
      {...props}
      initial="initial"
      whileHover="hovered"
      hasText={hasText}
    >
      {children}

      {hasText && (
        <Styled.LetterWrapper>
          {text.split('').map((letter, index) => (
            <Fragment key={index}>
              {letter !== ' ' ? (
                <Styled.LetterContainer>
                  <Styled.FirstLetter {...firstLetterAnimation(index)}>
                    {letter}
                  </Styled.FirstLetter>

                  <Styled.SecondLetter {...secondLetterAnimation(index)}>
                    {letter}
                  </Styled.SecondLetter>
                </Styled.LetterContainer>
              ) : (
                <span>&nbsp;</span>
              )}
            </Fragment>
          ))}
        </Styled.LetterWrapper>
      )}
    </Styled.FlipText>
  );
};

export default FlipText;
